const stickySectionsNav = () => {
    function debounced(func, wait, immediate) {
        var timeout
        return function() {
            var context = this,
                args = arguments
            var later = function() {
                timeout = null
                if (!immediate) func.apply(context, args)
            }
            var callNow = immediate && !timeout
            clearTimeout(timeout)
            timeout = setTimeout(later, wait)
            if (callNow) func.apply(context, args)
        }
    }

    const setNativeSmoothScrolling = () => {
        return document.documentElement.classList.add('-smooth-scroll');
    }

    const getHeightOfEl = selector => {
        let el = document.querySelector(selector)
        return el.getBoundingClientRect().height
    }

    const init = function() {
        console.log('sticky sections nav');
        const sectionLinksBlock = document.querySelector(
            '.section-navigation-links-block'
        )

        if(!sectionLinksBlock) return;

        setNativeSmoothScrolling()

        const featureBannerHero = document.querySelector(
            '.hero-section'
        )
        let heightOfHero = getHeightOfEl('.hero-section')
        let heightOfHeader = getHeightOfEl('.js-site-header')
        let heightToStick = heightOfHero - heightOfHeader

        const getPosition = function(el) {
            var xPos = 0
            var yPos = 0
            while (el) {
                if (el.tagName == 'BODY') {
                    // deal with browser quirks with body/window/document and page scroll
                    var xScroll = el.scrollLeft || document.documentElement.scrollLeft
                    var yScroll = el.scrollTop || document.documentElement.scrollTop
                    xPos += el.offsetLeft - xScroll + el.clientLeft
                    yPos += el.offsetTop - yScroll + el.clientTop
                } else {
                    // for all other non-BODY elements
                    xPos += el.offsetLeft - el.scrollLeft + el.clientLeft
                    yPos += el.offsetTop - el.scrollTop + el.clientTop
                }
                el = el.offsetParent
            }
            return {
                x: xPos,
                y: yPos,
            }
        }

        const stickyDebounced = debounced(function() {
            let positionOfHeader = getPosition(sectionLinksBlock)
            let positionOfHero = getPosition(featureBannerHero)
            if (positionOfHero.y > -heightToStick) {
                document.body.classList.remove('-section-nav-pinned')
            } else {
                document.body.classList.add('-section-nav-pinned')
            }
        }, 5)

        window.addEventListener('scroll', function() {
            stickyDebounced()
        })
    }
    init()
}
stickySectionsNav()
